import functions from "./functions";
const dictionary = {
  _toastTimeOut: 5000,
  _uiRefreshRate: 1000,
  apiHost: functions.getHost(),
};
export default dictionary;
